export const DEFAULT_ENVIRONMENT_INDEX = 0;
